import React, { useState } from "react";
import "./Inventory.css";
import { addInventory } from "../../network/api/endpoints";
import mainDb from "../../assets/db/main-db.json";
import { db } from "../../firebase/firebase";
import Toast from "../../components/common/Toast";
import loader from "../../assets/loader-imagine.gif";
import { Loader } from "../../components/Loader";
import { addDoc, collection, Timestamp } from "firebase/firestore";

function PdInventory() {

  
  const [inventoryList, setInventoryList] = useState([]);
  const [formData, setFormData] = useState({
    brand: "",
    model: "",
    category: "",
    notes: "",
    quantity: 1,
  });

  const allBrands = mainDb.brands;
  const [showDetails, setShowDetails] = useState(null);
  const [allModels, setAllModels] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const allCategories = ["I1", "I2", "I3", "I4", "I5"];

  const handleModelChange = (e) => {
    const selectedBrand = e.target.value;
    const models =
      allBrands.find((brand) => brand.name === selectedBrand)?.models || [];

    setAllModels(models);
    setFormData({
      ...formData,
      brand: selectedBrand,
      model: "",
    });
    resetModelSelection();
  };

  const handleVariantChange = (e) => {
    const selectedModel = e.target.value;
    const model = allModels.find((model) => model.name === selectedModel);

    setSelectedImage(model?.imageUrl || "");
    setFormData({ ...formData, model: selectedModel });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    console.log(formData);
    const { brand, model, category, quantity } = formData;

    if (!brand || !model || !category || quantity <= 0) {
      showToastNotification("Please fill in all required fields correctly.");
      return;
    }
    const updatedInventoryList = formData.id
      ? inventoryList.map((item) => (item.id === formData.id ? formData : item))
      : [...inventoryList, { ...formData, id: Date.now() }];

    setInventoryList(updatedInventoryList);
    resetForm();
  };
  const resetForm = () => {
    setFormData({
      brand: "",
      model: "",
      category: "",
      notes: "",
      quantity: 1,
    });
    resetModelSelection();
  };

  const toggleDetails = (index) => {
    setShowDetails(showDetails === index ? null : index);
  };

  const deleteItem = (index) => {
    setInventoryList(inventoryList.filter((_, i) => i !== index));
  };

  const handleFinalSubmit = async () => {
    setIsLoading(true);
    const inventoryRef = collection(db, "raw-inventory"); // Reference to your inventory collection

    try {
      // Using a loop to add each item to Firestore
      await Promise.all(
        inventoryList.map(async (item) => {
          try {
            // Add each item to the Firestore collection
            const itemWithDate = {
              ...item,
              createdAt: Timestamp.now(), // Add current date and time
            };
            await addDoc(inventoryRef, itemWithDate);
          } catch (error) {
            console.error("Error adding item:", error);
            showToastNotification(
              `Error adding item: ${error.message || error}`
            );
          }
        })
      );
      showToastNotification("All items successfully saved!");

      setInventoryList([]);
    } catch (error) {
      console.error("Network error:", error);
      showToastNotification(`Error: ${error.message || error}`);
    } finally {
      setIsLoading(false);
    }
  };

  const showToastNotification = (message) => {
    setToastMessage(message);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };

  const handleEdit = (index) => {
    const itemToEdit = inventoryList[index];
    setFormData(itemToEdit);
  };
  const resetModelSelection = () => {
    setSelectedImage(null);
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="container">
          <div className="add-inventory text-black">
            <h2>{formData.id ? "Edit Inventory" : "Add Inventory"}</h2>
            <div className="form-group">
              <div style={{ display: "flex", width: "100%" }}>
                <div className="select-side font-mono">
                  <select name="brand" onChange={handleModelChange} required>
                    <option value="">Select Brand</option>
                    {allBrands.map((brand) => (
                      <option key={brand.name} value={brand.name}>
                        {brand.name}
                      </option>
                    ))}
                  </select>

                  <select
                    name="model"
                    value={formData.model}
                    onChange={handleVariantChange}
                    required
                    // disabled={!formData.brand}
                  >
                    <option value="Select Model">Select Model</option>
                    {allModels.map((model) => (
                      <option key={model.id} value={model.name}>
                        {model.name}
                      </option>
                    ))}
                  </select>

                  <select
                    name="category"
                    value={formData.category}
                    onChange={handleChange}
                  >
                    <option value="">Select Category</option>
                    {allCategories.map((category) => (
                      <option key={category} value={category}>
                        {category}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="img-side">
                  {selectedImage && <img src={selectedImage} alt="Preview" />}
                </div>
              </div>

              <input
                type="number"
                name="quantity"
                placeholder="Quantity"
                value={formData.quantity}
                onChange={handleChange}
                onWheel={(e) => e.target.blur()}
              />

              <input
                type="text"
                name="notes"
                placeholder="Additional Note"
                value={formData.notes}
                onChange={handleChange}
              />
              {/* <input
                type="number"
                name="purchasePrice"
                placeholder="Purchase Price"
                // value={formData.purchasePrice}
                onChange={handleChange}
                disabled={true}
                className="cursor-not-allowed"
              /> */}
              {/* <input
                type="number"
                name="sellingPrice"
                placeholder="Selling Price"
                // value={formData.sellingPrice}
                onChange={handleChange}
                disabled={true}
                className="cursor-not-allowed"
              /> */}
              {/* <input
                type="number"
                name="imei_1"
                placeholder="IMEI No.1"
                // value={formData.imei_1}
                onChange={handleChange}
                disabled={true}
                className="cursor-not-allowed"
              /> */}
              {/* <input
                type="number"
                name="imei_2"
                placeholder="IMEI No.2"
                // value={formData.imei_2}
                onChange={handleChange}
                disabled={true}
                className="cursor-not-allowed"
              /> */}

              <button onClick={handleSubmit}>
                {formData.id ? "Update" : "Add"}
              </button>
              {showToast && (
                <Toast
                  message={toastMessage}
                  onClose={() => setShowToast(false)}
                />
              )}
            </div>
          </div>

          <div className="inventory-list">
            <h2>Inventory List</h2>
            {inventoryList.map((item, index) => (
              <div key={index} className="inventory-item">
                <div className="item-header">
                  <div
                    className="item-name"
                    onClick={() => toggleDetails(index)}
                  >
                    <span className="toggle-icon">
                      {showDetails === index ? "🔽" : "🔼"}
                    </span>
                    <span>
                      {item.brand} - {item.model}
                    </span>
                  </div>
                  <div className="flex">
                    <button
                      className="edit-button mr-1"
                      onClick={() => handleEdit(index)}
                    >
                      Edit
                    </button>

                    <button
                      className="delete-button"
                      onClick={() => deleteItem(index)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
                {showDetails === index && (
                  <div className="item-details">
                    {Object.entries(item).map(
                      ([key, value]) =>
                        key !== "name" &&
                        key !== "category" && (
                          <p key={key} className="item-detail">
                            <span className="item-key">
                              {key.charAt(0).toUpperCase() +
                                key.slice(1).replace(/_/g, " ")}
                              :
                            </span>{" "}
                            <span className="item-value">{value}</span>
                          </p>
                        )
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      <div
        style={{
          marginTop: "-130px",
          marginLeft: "-90px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "110%",
          padding: "15px",
          background:
            "linear-gradient(to right, rgba(255, 0, 0, 0) 5%, #F70D1A 50%, rgba(255, 0, 0, 0) 95%)",
        }}
      >
        <button
          onClick={handleFinalSubmit}
          style={{
            width: "200px",
            backgroundColor: "white",
            color: "black",
            fontSize: "large",
          }}
        >
          Save
        </button>
        {loader && (
          <div
            className="loader"
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "20px 0",
            }}
          />
        )}
      </div>
    </>
  );
}

export default PdInventory;
